/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    parseDate,
    parseDateTime,
    serializeDate,
    serializeDateTime
} from '../runtime'
import type { V1MotiPayload } from './V1MotiPayload'
import {
    instanceOfV1MotiPayload,
    V1MotiPayloadFromJSON,
    V1MotiPayloadFromJSONTyped,
    V1MotiPayloadToJSON
} from './V1MotiPayload'
import type { V1MotiWorkoutsFeed } from './V1MotiWorkoutsFeed'
import {
    instanceOfV1MotiWorkoutsFeed,
    V1MotiWorkoutsFeedFromJSON,
    V1MotiWorkoutsFeedFromJSONTyped,
    V1MotiWorkoutsFeedToJSON
} from './V1MotiWorkoutsFeed'

/**
 * @type SendRequest
 *
 * @export
 */
export type SendRequest = V1MotiPayload | V1MotiWorkoutsFeed

export function SendRequestFromJSON(json: any): SendRequest {
    return SendRequestFromJSONTyped(json, false)
}

export function SendRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): SendRequest {
    if (json == null) {
        return json
    }
    if (typeof json !== 'object') {
        return json
    }
    if (instanceOfV1MotiPayload(json)) {
        return V1MotiPayloadFromJSONTyped(json, true)
    }
    if (instanceOfV1MotiWorkoutsFeed(json)) {
        return V1MotiWorkoutsFeedFromJSONTyped(json, true)
    }
    return {} as any
}

export function SendRequestToJSON(json: any): any {
    return SendRequestToJSONTyped(json, false)
}

export function SendRequestToJSONTyped(
    value?: SendRequest | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }
    if (typeof value !== 'object') {
        return value
    }
    if (instanceOfV1MotiPayload(value)) {
        return V1MotiPayloadToJSON(value as V1MotiPayload)
    }
    if (instanceOfV1MotiWorkoutsFeed(value)) {
        return V1MotiWorkoutsFeedToJSON(value as V1MotiWorkoutsFeed)
    }
    return {}
}
